import { useEffect } from 'react';
import { CircleCheck, CircleX, X } from 'lucide-react';

export interface IToast {
  tone: 'success' | 'error';
  title: string;
  message?: string;
}

interface ToastProps extends IToast {
  onClose: () => void;
}

export function Toast({ tone, title, message, onClose }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose, title, message]);

  const success = tone === 'success';
  const Icon = success ? CircleCheck : CircleX;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed bottom-6 right-6 z-50 flex w-80 items-start gap-3 rounded-lg border bg-white p-4 shadow-lg ${
        success ? 'border-emerald-200' : 'border-red-200'
      }`}
    >
      <Icon
        aria-hidden
        className={`mt-0.5 h-5 w-5 shrink-0 ${success ? 'text-emerald-600' : 'text-red-600'}`}
      />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-gray-900">{title}</p>
        {message && <p className="mt-0.5 text-sm text-gray-600">{message}</p>}
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Dismiss"
        className="text-gray-400 hover:text-gray-600"
      >
        <X aria-hidden className="h-4 w-4" />
      </button>
    </div>
  );
}
